export interface UserOrganization {
  userId: number;
  orgId: number;
  orgName: string;
  orgLogo: string;
}
